<template>
  <div class="removal">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon color="pink" v-on="on">
          icon-change-removed
        </v-icon>
      </template>
      <span>{{ $t("message.externalChanges.removalTooltip") }}</span>
    </v-tooltip>
    <div class="removal__wrapper">
      <div>
        <p class="field-name"><slot name="field"></slot></p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "GeneralRemoval"
};
</script>

<style lang="scss" scoped>
.removal {
  display: flex;
  align-items: flex-start;

  & > i {
    margin-right: $spacing * 3;
  }

  & p {
    margin-bottom: 0;
    line-height: 24px;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
  }

  .field-name {
    @include font-size(14px);
    opacity: 0.6;
    margin-bottom: $spacing * 0.5;
  }
}
</style>
